var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"text-right"},[_c('button',{staticClass:"button-round p-4 w-20 h-20 m-4 pointer-events-auto",class:_vm.buttonClasses,attrs:{"disabled":_vm.disabled,"data-cy":"button-round"},on:{"click":_vm.click}},[_c('HokIcon',{attrs:{"icon":_vm.iconName,"color":"white","size":12}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }